export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14834.5e696b55.jpg";